<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row" v-if="userData.permissions['view_investment']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['view_investment']==1" v-b-modal.new-investment size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Investment</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
              </template>
              <template #cell(description)="data">
                {{ data.item.description }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.name,data.item.location,data.item.description )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Investments</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-investment" centered title="New Investment" title-class="font-18" hide-footer>
        <form @submit.prevent="addInvestment">
            <div class="form-group mb-2">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Location</label>
            <input v-model="location" type="text" class="form-control" />
            <label>Description</label>
            <textarea v-model="description" type="text" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-investment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-investment" centered title="Edit Investment" title-class="font-14" hide-footer>
        <form @submit.prevent="editInvestment">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Location</label>
            <input v-model="location" type="text" class="form-control" />
            <label>Description</label>
            <textarea v-model="description" type="text" class="form-control" ></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-investment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-investment" centered title="Delete Investment" title-class="font-18" hide-footer>
        <form @submit.prevent="removeInvestment">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Investment : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-investment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
 
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { investmentMethods, investmentComputed } from "@/state/helpers";

export default {
  page: {
    title: "Investments",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Investments",
      items: [ {text: "Dashboard",to: "/",}, {text: "Investments",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'location', label: 'Location', visible: true },
          { key: 'description', label: 'Description', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      location:'',
      description:'',
    };
  },
  computed: {
    ...investmentComputed,
    List() { return this.investments.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.investments.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.investments.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchInvestments();
    this.TotalRows = this.investments.length;
    this.isBusy=false;
  },
  methods: {
    ...investmentMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name,location,description){
      this.id=id;
      this.name=name;
      this.location=location;
      this.description=description;
      this.$bvModal.show('edit-investment')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-investment')
    },
    async addInvestment() { 
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("location", this.location);
      formData.append("description", this.description);
      let url = "/addinvestment";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchInvestments();
          this.$bvModal.hide('new-investment');
          this.name="";
          this.description="";
          this.location="";
      }
      });
    },
    async editInvestment(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    formData.append("location", this.location);
    formData.append("description", this.description);
    let url = "/updateinvestment";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchInvestments();
        this.$bvModal.hide('edit-investment');
        this.name="";
        this.location="";
        this.description="";
      }
    });
    },
    async removeInvestment() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeinvestment";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchInvestments();
        this.$bvModal.hide('delete-investment');
      }
    });
    },
  },
};
</script>